// Factory function pattern to avoid Webpack TDZ issues with class inheritance
// This replaces BaseAdmin class with a factory function that uses BaseApiServiceFactory

import { createBaseApiService, type IBaseApiService } from "@Front/Api/BaseApiServiceFactory";

export interface IBaseAdmin extends IBaseApiService {
	namespaceUrl: string;
}

export function createBaseAdmin(): IBaseAdmin {
	const baseApi = createBaseApiService();

	return {
		...baseApi,
		get namespaceUrl(): string {
			return baseApi.getBaseUrl().concat("/admin");
		},
	};
}
